import * as React from "react";
const baseClass = "rj-pulse-bet-markets__msg";
export class GeneralMessage extends React.Component {
    render() {
        const { modifier, text } = this.props;
        const cls = modifier ? `${baseClass} ${baseClass}--${modifier}` : baseClass;
        return (React.createElement("div", { className: cls },
            React.createElement("span", { className: "rj-pulsebet-markets__message-text" }, text)));
    }
}
//# sourceMappingURL=GeneralMessage.js.map